import React from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import crf_banner from '../../../../assets/change_header.jpg';

const styles = StyleSheet.create({
    relative:{
        position:'relative',
        top: 0,
    },
    footsection: {
        margin: 10,
        marginBottom: 5,
        paddingHorizontal: 20,
        fontSize: 13,
        textAlign: "left",
        fontWeight: 400,
        color: "#222",
        lineHeight: 1.5,
    },
    footerTextLeft: {
        textAlign: "left",
        fontSize: 8.9,
    },
    textRight: {
        textAlign: "right",
        fontSize: 8.9,
        marginTop: -15,
    },
    textUnderline: {
        textDecoration: "underline",
        width: "100%",
        display:"block",
    },
    section: {
        margin: 10,
        marginBottom: 5,
        paddingHorizontal: 20,
        fontSize: 13,
        textAlign: "left",
        fontWeight: 400,
        color: "#222",
        lineHeight: 1.5,
    },
    footer: {
        marginTop: 20,
        fontSize: 11,
        fontWeight: 300,
        color: "#222",
        lineHeight: 1.2,
        position:"absolute",
        bottom: 15,
        left: 20,
    },
    rightSection: {
        textAlign: "right",
    },
    text: {
        fontSize: 12,
        textAlign: "left",
        fontWeight: 400,
        color: "#222",
        lineHeight: 1.7,
        display:"block",
        width: "100%",
    },
    textLeft: {
        textAlign: "left",
        fontSize: 12,
        marginBottom: 0,
    },
    table: {
        padding: 0,
        margin: 0,
        fontSize: 10,
    },
    textBold: {
        fontWeight: "bold",
    },
    row: {
        alignItems: "center",
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #000',
        borderLeft: '1px solid #000',
        padding: 0,
        margin: 0,
    },
    tablehead: {
        alignItems: "stretch",
        justifyContent: 'center', // align the children vertically
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #000',
        backgroundColor: '#000',
        color:'#fff',
        padding: 0,
        margin: 0,
    },
    tablesubhead: {
        alignItems: "stretch",
        justifyContent: 'left', // align the children vertically
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #999',
        backgroundColor: '#999',
        color:'#fff',
        padding: 0,
        margin: 0,
    },
    bodyrow: {
        alignItems: "stretch",
        justifyContent: 'center', // align the children vertically
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #000',
        // borderLeft: '1px solid #000',
        padding: 0,
        margin: 0,
    },
    tablerow: {
        alignItems: "stretch",
        justifyContent: 'center', // align the children vertically
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        margin: 0,
        height: 24,
    },
    th: {
        fontWeight: 800,
        fontSize: 11,
        padding: 4,
        margin: 0,
        backgroundColor: "#eee",
        borderLeft: '1px solid #000',
        color: "#000"
    },
    mainHeaderTitle: {
        width: '100%', 
        backgroundColor: '#000', 
        color:'#fff', 
        fontSize: 15, 
        fontWeight: 900, 
        borderRight:'1px solid #000',
        borderBottom:'1px solid #000', 
        borderLeft:'1px solid #000', 
        paddingLeft: 10, 
        paddingBottom: 0 
    },
    subHeaderTitle: {
        width: '100%', 
        backgroundColor: '#bbb', 
        color:'#000', 
        fontSize: 12,
        textAlign:'center', 
        fontWeight: 800, 
        borderRight:'1px solid #000',
        borderLeft:'1px solid #000', 
        paddingLeft: 10, 
        paddingBottom: 0 
    },
    thtransparent: {
        fontWeight: "bold",
        fontSize: 10,
        padding: 4,
        paddingLeft: 0,
        margin: 0,
        color: "#000"
    },
    thd: {
        overflow: 'hidden',
        fontSize: 9,
        padding: 4,
        margin: 0,
        backgroundColor: "#fff",
        color: "#444",
        borderLeft: "1px solid #000",
        borderBottom: "1px solid #000",
        borderTopWidth: 0,
    },
    thtranstitle: {
        fontWeight: "800",
        fontSize: 11,
        padding: 4,
        paddingLeft: 10,
        margin: 0,
        backgroundColor: "#fff",
        borderLeft: '1px solid #000',
        borderRight: '1px solid #000',
    },
    thtrans: {
        fontWeight: "bold",
        fontSize: 9,
        padding: 4,
        paddingLeft: 10,
        margin: 0,
        backgroundColor: "#fff",
        borderLeft: '1px solid #000',
        borderRight: '1px solid #000',
    },
    foot: {
        alignItems: "stretch",
        justifyContent: 'center', // align the children vertically
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #000',        
        padding: 0,
        margin: 0,
    },
    td: {
        overflow: 'hidden',
        fontSize: 9,
        padding: 4,
        margin: 0,
        backgroundColor: "#fff",
        color: "#444",
        borderLeft: "1px solid #000",
        borderRight: "1px solid #000",
        borderBottom: "1px solid #000",
        borderTopWidth: 0,
    },
    desc10: {
        width: "10%",
    },
    desc50: {
        width: "50%",
    },
    desc80: {
        width: "80%",
    },
    desc20: {
        width: "20%",
    },
    desc30: {
        width: "30%",
        textAlign: "left",
    },
    desc70: {
        width: "70%",
        textAlign: "left",
    },
    desc50left: {
        width: "50%",
        textAlign:"left",
    },
    desc100left: {
        width: "100%",
        textAlign:"left",
    },
});

const TableHead = () => {
    return (
        <>
            <View style={[styles.tablehead]}>
                <Text style={[styles.th, styles.desc10]}>SN</Text>
                <Text style={[styles.th, styles.desc70]}>Item Description</Text>
                <Text style={[styles.th, styles.desc20]}>Due Date</Text>
            </View>
        </>
    )
}

const MainHeader = ({ title }) => {
    return (
        <View style={[ styles.bodyrow ]}>
            <Text style={[styles.th, styles.mainHeaderTitle]}>{title}</Text>
        </View>
    )
}

const SubHead = ({ title }) => {
    return (
        <View style={[ styles.bodyrow ]}>
            <Text style={[styles.th, styles.subHeaderTitle]}>{title}</Text>
        </View>
    )
}

const RiskOpportunityHead = () => {
    return (
        <>
            <View style={[styles.tablesubhead]}>
                <Text style={[styles.th, styles.desc10]}>SN</Text>
                <Text style={[styles.th, styles.desc30]}>Risk</Text>
                <Text style={[styles.th, styles.desc20]}>Action</Text>
                <Text style={[styles.th, styles.desc20]}>Responsibility</Text>
                <Text style={[styles.th, styles.desc20, { borderRight: "1px solid #999"}]}>Timeline</Text>
            </View>
        </>
    )
}

const RiskOpportunityBody = ({ body }) => {
    return (
        body && body).map((item, i) => (
            <View style={[styles.bodyrow]} key={i}>
                <Text style={[styles.td, styles.desc10]}>{i + 1}</Text>
                <Text style={[styles.td, styles.desc30]}>{item.risk && item.risk}</Text>
                <Text style={[styles.td, styles.desc20]}>{item.action && item.action}</Text>
                <Text style={[styles.td, styles.desc20]}>{item.responsibility && item.responsibility}</Text>
                <Text style={[styles.td, styles.desc20]}>{item.timeline && item.timeline}</Text>
            </View>
        )
    )
}


export const DocChangeRequest = ({ crf }) => {

    return (
        <>
            <View style={{position: "relative"}}>
                <View fixed style={{ top: 0, left: 0, right: 0}}>
                    <Image
                        src={crf_banner}
                        style={{
                            height: 110,
                            width: "100%",
                            marginTop: 20,
                            paddingRight: 20,
                            paddingLeft: 20,
                            marginBottom: 0,
                        }} 
                    />
                </View>

                {/* Page Content */}
                <View>
                    <View style={styles.section}>
                        <View style={{width: '100%', textAlign:'left', fontSize: 13, fontWeight: 'bold' }}>
                            <Text style={{width: '100%', textAlign:'left', fontSize: 13, fontWeight: 'bold' }}>
                                <strong>RS-CSD-PPM-HBP-P-10508-1 CHANGE REQUEST FORM</strong>
                            </Text>
                        </View>
                    </View>
                    
                    <View style={styles.section}>
                        <View style={[styles.tablerow]}>
                            <Text style={[styles.thtransparent, styles.desc50left]}>
                                <b>Change Request No</b>: {crf && crf.documentNo}
                            </Text>
                            <Text style={[styles.thtransparent, styles.desc50left]}>
                                <b>Date</b>: {crf && crf.createdAt}
                            </Text>
                        </View>
                        <View style={[styles.tablerow]}>
                            <Text style={[styles.thtransparent, styles.desc50left]}>
                                <b>Change Initiator:</b> {crf && crf.createdBy?.userName}
                            </Text>
                            <Text style={[styles.thtransparent, styles.desc50left]}>
                                <b>EID:</b> {crf && (crf.createdBy?.userName)}
                            </Text>
                        </View>
                    </View>

                    <View style={[styles.section, { marginBottom: 0}]}>
                        <MainHeader title="Change Impact Assessment: Completed by Change Initiator" />

                        <View style={[ styles.bodyrow ]}>
                            <Text style={[styles.thtranstitle, styles.desc100left]}>REQUEST DESCRIPTION</Text>
                            <Text style={[styles.thtrans, styles.desc100left]}>{crf && crf.requestDescription}</Text>
                        </View>
                        <View style={[ styles.bodyrow ]}>
                            <Text style={[styles.thtranstitle, styles.desc100left]}>BUSINESS OR TECHNICAL JUSTIFICATION</Text>
                            <Text style={[styles.thtrans, styles.desc100left]}>{crf && crf.justification}</Text>
                        </View>
                        <View style={[ styles.bodyrow ]}>
                            <Text style={[styles.thtranstitle, styles.desc100left]}>RESOURCE REQUIREMENTS</Text>
                            <Text style={[styles.thtrans, styles.desc100left]}>{crf && crf.resourceRequirements}</Text>
                        </View>
                        <View style={[ styles.bodyrow ]}>
                            <Text style={[styles.thtranstitle, styles.desc100left]}>BUDGET PROJECTION</Text>
                            <Text style={[styles.thtrans, styles.desc100left]}>{crf && crf.budgetProjection}</Text>
                        </View>
                        <View style={[ styles.bodyrow ]}>
                            <Text style={[styles.thtranstitle, styles.desc100left]}>PRIORITY</Text>
                            <Text style={[styles.thtrans, styles.desc100left]}>{crf && crf.priority}</Text>
                        </View>

                        <SubHead title="PROJECT TIMELINES" />

                        <TableHead />

                        <View style={styles.table}>
                            {(crf && crf.timelines).map((item, i) => (
                                <View key={i}>
                                    <View  style={[styles.bodyrow]}>
                                        <Text style={[styles.td, styles.desc10]}>{i + 1}</Text>
                                        <Text style={[styles.td, styles.desc70]}>{item.action && item.action}</Text>
                                        <Text style={[styles.td, styles.desc20]}>{item.dueDate && item.dueDate}</Text>
                                    </View>
                                </View>
                            ))}
                        </View>

                        <SubHead title="EXPECTED OUTCOMES" />

                        <View style={styles.table}>
                            {(crf && crf.outcomes).map((item, i) => (
                                <View key={i}>
                                    <View  style={[styles.bodyrow]}>
                                        <Text style={[styles.td, styles.desc100left]}>
                                            {item.description && item.description}
                                        </Text>
                                    </View>
                                </View>
                            ))}
                        </View>                        
                    </View>
                    
                    <View style={styles.section}>
                        <MainHeader title="Change Impact Assessment: Completed by BSP Unit & Change Coordinator" />

                        <SubHead title="Risk Factors" />
                        <RiskOpportunityHead />
                        <RiskOpportunityBody body ={crf.riskFactors} />
                        <SubHead title="Opportunity Factors" />
                        <RiskOpportunityHead />
                        <RiskOpportunityBody body ={crf.opportunityFactors} />
                    </View>

                    <View style={styles.section}>
                        <MainHeader title="Change Request Resolution" />
                        
                        <View style={[styles.tablerow]}>
                            <Text style={[styles.thtransparent, styles.desc50left]}>
                                <b>Change Request Decision</b>: {crf && crf.decision}
                            </Text>
                            <Text style={[styles.thtransparent, styles.desc50left]}>
                                <b>Training Required</b>: {crf && crf.trainingRequired}
                            </Text>
                        </View>
                        <View style={[styles.tablerow]}>
                            <Text style={[styles.thtransparent, styles.desc50left]}>
                                <b>Change Coordinator</b>: {crf && crf.reviewedBy?.userName}
                            </Text>
                            <Text style={[styles.thtransparent, styles.desc50left]}>
                                <b>EID</b>: {crf && crf.reviewedBy?.userName}
                            </Text>
                        </View>
                        <View style={[styles.tablerow]}>
                            <Text style={[styles.thtransparent, styles.desc100left]}>
                                <b>Decision Recommendation</b>: {crf && crf.recommendation}
                            </Text>
                        </View>
                        <View style={[styles.tablerow]}>
                            <Text style={[styles.thtransparent, styles.desc100left]}>
                                <b>Reason for Decision</b>: {crf && crf.recommendation}
                            </Text>
                        </View>
                        <View style={[styles.tablerow]}>
                            <Text style={[styles.thtransparent, styles.desc50left]}>
                                <b>Decision Approver</b>: {crf && crf.approvedBy?.userName}
                            </Text>
                            <Text style={[styles.thtransparent, styles.desc50left]}>
                                <b>Decision Date</b>: {crf && crf.approvedAt}
                            </Text>
                        </View>
                    </View>

                    <View fixed style={[styles.footsection, { bottom: 0, left: 0, right: 0}]}>
                        <Text style={styles.textUnderline}>{"__________________________________________________________________________"}</Text>
                        <Text style={[styles.footerTextLeft]}>RS-CSD-PPM-HBP-P-10508 Change Management</Text>
                        <Text style={[styles.textRight]}>Unauthorized Printing Is Not Permitted</Text>
                                        
                    </View>

                </View>
            </View>
        </>
    )
}

export default DocChangeRequest;